import React, { useEffect, useMemo, useRef } from "react";
import Axios from "axios";
import { bindActionCreators } from "redux";
import { useSelector, useDispatch } from "react-redux";
import { Creators } from "../../../store/ducks/weightGainProjection";

import { Row, Col, Table, Menu, Dropdown, Icon } from "antd";
import { Container, Title, CardCustom } from "./styles";
import TagStatus from "../../../components/utils/tagStatus";
import { Container as MenuContainer } from "../../../components/utils/table/menu/styles";
import MenuIcon from "../../../components/utils/table/icons/menu";
import ButtonStandard from "../../../components/utils/button";
import WeightGainProjectionDrawer from "../../../components/drawers/weightGainProjection";

const WeightGainProjection = () => {
  const app = useSelector((state) => state.app);
  const { isLoading, data } = useSelector(
    (state) => state.weightGainProjection,
  );
  const dispatch = useDispatch();

  const weightGainProjectionActions = useMemo(
    () => bindActionCreators(Creators, dispatch),
    [dispatch],
  );

  const signal = useRef(Axios.CancelToken.source());

  useEffect(() => {
    const { groupSelected, farmSelected } = app;
    const cancelToken = signal.current;
    if (
      Object.entries(groupSelected).length > 0 &&
      Object.entries(farmSelected).length > 0
    ) {
      const { id: groupId } = groupSelected;
      const { id: farmId } = farmSelected;
      weightGainProjectionActions.indexWeightGainProjection(
        groupId,
        farmId,
        0,
        {},
        "",
        true,
        null,
        signal.current,
      );
    }
    return () => cancelToken.cancel("Cancelando apis");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleActivateOrInactivate = (id, record, action) => {
    const {
      groupSelected: { id: groupId },
      farmSelected: { id: farmId },
    } = app;
    weightGainProjectionActions.inactivateOrActivateWeightGainProjection(
      groupId,
      farmId,
      id,
      record,
      action,
    );
  };

  const handleNewProjection = () => {
    weightGainProjectionActions.showDrawerWeightGainProjection(null);
  };

  const handleRefresh = () => {
    const { groupSelected, farmSelected } = app;
    const { id: groupId } = groupSelected;
    const { id: farmId } = farmSelected;
    weightGainProjectionActions.indexWeightGainProjection(
      groupId,
      farmId,
      0,
      {},
      "",
      true,
      null,
      signal.current,
    );
  };

  const menu = (id, record) => {
    const { translation } = app;
    return (
      <Menu>
        {record?.status === "Inactive" && (
          <Menu.Item
            key="activate"
            onClick={() => handleActivateOrInactivate(id, record, "activate")}
          >
            {translation.table.menu.activate}
          </Menu.Item>
        )}
        {record?.status === "Active" && (
          <Menu.Item
            key="edit"
            onClick={() =>
              weightGainProjectionActions.showDrawerWeightGainProjection(record)
            }
          >
            {translation.table.menu.edit}
          </Menu.Item>
        )}
        {record?.status === "Active" && (
          <Menu.Item
            key="inactivate"
            onClick={() => handleActivateOrInactivate(id, record, "inactivate")}
          >
            {translation.table.menu.inactivate}
          </Menu.Item>
        )}
      </Menu>
    );
  };

  const { translation } = app;
  const Column = Table.Column;

  return (
    <Container>
      <CardCustom>
        <Row type="flex" justify="space-between" className="rowHeader">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Title>{translation.weightGainProjection.title}</Title>
          </Col>
          <Col xs={8} sm={8} md={8} lg={8} xl={8}>
            <Row type="flex" justify="end">
              <Col>
                <ButtonStandard
                  buttonType="typeWithoutBackground"
                  onClick={handleRefresh}
                >
                  <Icon type="reload" />
                </ButtonStandard>
              </Col>
              <Col>
                <ButtonStandard
                  type="button"
                  buttonType="addNew"
                  onClick={handleNewProjection}
                >
                  {translation.weightGainProjection.buttonNew}
                </ButtonStandard>
              </Col>
            </Row>
          </Col>
        </Row>
        <Table
          rowKey="id"
          size="small"
          dataSource={data != null ? data : []}
          scroll={{
            x: 800,
            y: 758,
          }}
          pagination={{
            showSizeChanger: true,
            defaultPageSize: 10,
            pageSizeOptions: ["10", "20", "30", "100", "500", "1000", "2000"],
            hideOnSinglePage: true,
          }}
          loading={isLoading}
        >
          <Column
            title={translation.weightGainProjection.table.status}
            dataIndex="status"
            key="status"
            align="left"
            sorter={(first, second) => {
              return first.status.localeCompare(second.status, "pt-BR", {
                numeric: false,
                ignorePunctuation: true,
              });
            }}
            filtered
            filters={[
              {
                text: translation.status.active,
                value: "Active",
              },
              {
                text: translation.status.inactive,
                value: "Inactive",
              },
            ]}
            filterMultiple
            defaultFilteredValue={["Active"]}
            onFilter={(value, record) => record.status.includes(value)}
            render={(status) =>
              status === "Active" ? (
                <TagStatus
                  background="#C5F1CA"
                  borderColor="#106518"
                  color="#106518"
                >
                  {translation.status.active}
                </TagStatus>
              ) : status === "Inactive" ? (
                <TagStatus
                  background="#FBC7C7"
                  borderColor="#D44C4C"
                  color="#D44C4C"
                >
                  {translation.status.inactive}
                </TagStatus>
              ) : null
            }
          />

          <Column
            title={translation.weightGainProjection.table.name}
            dataIndex="name"
            key="name"
            align="left"
            sorter={(first, second) => {
              return first.name.localeCompare(second.name, "pt-BR", {
                numeric: false,
                ignorePunctuation: true,
              });
            }}
          />

          <Column
            title={translation.weightGainProjection.table.informType}
            dataIndex="informType"
            key="informType"
            align="left"
            filters={[
              {
                text: translation.weightGainProjection.informType.period,
                value: "PERIOD",
              },
              {
                text: translation.weightGainProjection.informType.fixed,
                value: "FIXED",
              },
            ]}
            filterMultiple
            onFilter={(value, record) => record.informType === value}
            render={(informType) =>
              informType === "PERIOD" ? (
                <TagStatus
                  background="#e6f7ff"
                  borderColor="#1890ff"
                  color="#1890ff"
                >
                  {translation.weightGainProjection.informType.period}
                </TagStatus>
              ) : informType === "FIXED" ? (
                <TagStatus
                  background="#f6ffed"
                  borderColor="#52c41a"
                  color="#52c41a"
                >
                  {translation.weightGainProjection.informType.fixed}
                </TagStatus>
              ) : null
            }
          />

          <Column
            align="left"
            render={(text, record) => (
              <Dropdown
                overlay={menu(record.id, record)}
                trigger={["click"]}
                key={record.id}
              >
                <MenuContainer>
                  <MenuIcon />
                </MenuContainer>
              </Dropdown>
            )}
          />
        </Table>
      </CardCustom>
      <WeightGainProjectionDrawer />
    </Container>
  );
};

export default WeightGainProjection;
